import { render, staticRenderFns } from "./purchaseModal.vue?vue&type=template&id=b9b2613c&scoped=true"
import script from "./purchaseModal.vue?vue&type=script&lang=js"
export * from "./purchaseModal.vue?vue&type=script&lang=js"
import style0 from "./purchaseModal.vue?vue&type=style&index=0&id=b9b2613c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b2613c",
  null
  
)

export default component.exports